interface DownloadPropertyImportTemplateInput {
  dataSheetName: string;
  helpSheetName: string;
  headerList: string[];
  helpRowList: string[][];
  dataRowList?: string[][];
  fileName?: string;
  shouldDownload?: () => boolean;
}

export async function downloadPropertyImportTemplate({
  dataSheetName,
  helpSheetName,
  headerList,
  helpRowList,
  dataRowList = [],
  fileName = "properties-template.xlsx",
  shouldDownload,
}: DownloadPropertyImportTemplateInput): Promise<void> {
  const { default: ExcelJS } = await import("exceljs");
  const workbook = new ExcelJS.Workbook();
  const dataSheet = workbook.addWorksheet(dataSheetName);
  dataSheet.addRow(headerList);
  dataSheet.addRows(dataRowList);
  dataSheet.columns.forEach((column) => {
    column.width = 24;
    column.numFmt = "@";
  });
  dataSheet.views = [{ state: "frozen", ySplit: 1 }];
  const helpSheet = workbook.addWorksheet(helpSheetName);
  helpSheet.addRows(helpRowList);
  helpSheet.columns = [{ width: 30 }, { width: 60 }, { width: 110 }];
  helpSheet.eachRow((row) => {
    row.alignment = { vertical: "top", wrapText: true };
    row.height = 48;
    if (row.cellCount === 1) {
      helpSheet.mergeCells(row.number, 1, row.number, 3);
      row.height = 64;
    }
  });
  for (const sheet of [dataSheet, helpSheet]) {
    sheet.getRow(1).font = { bold: true, color: { argb: "FFFFFFFF" } };
    sheet.getRow(1).fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF234E52" } };
  }
  const buffer = await workbook.xlsx.writeBuffer();
  if (shouldDownload?.() === false) return;
  const url = URL.createObjectURL(
    new Blob([new Uint8Array(buffer)], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    }),
  );
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(url);
}
